var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('data-table',{attrs:{"table-ref":"rentalsummarytable","title":"Rentals/Lease","icon":"fa fa-hand-holding-usd","search-placeholder":"Site name, Landlord","url":"/report/property/rentals/summary","fields":_vm.fields}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }